const NAMASTAY_SDK_URL = 'https://sdk.namastay.io/index.js';

const NAMASTAY_WIDGET_BUTTONS_CLASS = 'namastay-widget-button';
const NAMASTAY_OFFER_BUTTONS_CLASS = 'namastay-offer-button';

const hotelParameters = {
	apiKey: '32e57b5c878845008db932e5e90d7a4b54itx3f3r15d129r',
	spreedlyApiKey: 'D1a8Zma8lZfap6nZpUjPxp6OHBV',
	widgetButtonsClass: NAMASTAY_WIDGET_BUTTONS_CLASS,
	specialOfferButtonsClass: NAMASTAY_OFFER_BUTTONS_CLASS,
};

/**
 * Load the Namastay booking engine SDK.
 *
 * The SDK clones and replaces every widget button, which doesn't play well with
 * elements rendered by Vue. Therefore all booking buttons on the site use the
 * offer button class, which is handled with a delegated click listener.
 * The SDK only sets up that listener when at least one widget button exists,
 * so a hidden widget button is added outside of the Vue app.
 */
export default defineNuxtPlugin(() => {
	const widgetButton = document.createElement('span');
	widgetButton.className = NAMASTAY_WIDGET_BUTTONS_CLASS;
	widgetButton.hidden = true;
	document.body.appendChild(widgetButton);

	const script = document.createElement('script');
	script.src = NAMASTAY_SDK_URL;
	script.async = true;
	script.onload = () => {
		window.initNamastay(hotelParameters);
	};
	document.body.appendChild(script);
});
